import { useConfig } from "@jti/app-context/useConfig";
import { useSelector } from "@jti/store/reduxHooks";
import { selectPrices } from "@jti/store/selectors/selectPrices";
import { FormattedPrice, useTranslations } from "@jti/ui";

import styles from "./SubscriptionPrices.module.scss";

export const SubscriptionPrices = () => {
  const { __ } = useTranslations();
  const { showPricesWithTaxExcluded = false } = useConfig();

  const priceList = useSelector((state) => selectPrices(state, showPricesWithTaxExcluded));

  const shippingPrice = priceList?.shipping;
  const subscriptionAmount = priceList?.subscriptionAmount;

  return (
    <div className={styles.subscriptionPricesContainer}>
      {subscriptionAmount ? (
        <div className={styles.pricesBox}>
          <p>{__("summarySubscription.monthlyBilling")}</p>
          <p className={styles.boldInformation}>
            <b>
              <FormattedPrice value={subscriptionAmount.value} currency={subscriptionAmount.currency} />
            </b>
          </p>
        </div>
      ) : (
        ""
      )}
      {shippingPrice ? (
        <div className={styles.pricesBox}>
          <p>{__("summarySubscription.shipping")}</p>
          <p className={styles.boldInformation}>
            <b>
              <FormattedPrice value={shippingPrice.value} currency={shippingPrice.currency} />
            </b>
          </p>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
